import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {getCostInformation} from '../ui_game_help_buttons/ui_game_help_buttons_information_button/UIGameCostsInformation'
import {ActionState, MechanicDevelopmentCardsState, MechanicProgressCardsState, TurnState} from '@colonist/game-states'
import {GameAction, ModeSettingEnum} from '@colonist/game-base-types'
import {MechanicValidatorDevelopmentCard, MechanicValidatorProgressCards} from '@colonist/game-mechanic-validators'

export class UIGameActionSuggestionController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly SUGGESTION_TIMEOUT = 5000
    private endTurnSuggestionTimeout: NodeJS.Timeout | undefined
    private alreadySuggestedToEndTurn: boolean = false

    private readonly devCardsValidator?: MechanicValidatorDevelopmentCard
    private readonly progressCardsValidator?: MechanicValidatorProgressCards

    constructor(uiGameManager: UIGameManager, developmentCardsState: MechanicDevelopmentCardsState | undefined, progressCardsState: MechanicProgressCardsState | undefined) {
        if(uiGameManager.gameController.gameSettings.modeSetting == ModeSettingEnum.BeginnerModeClassic4P) return
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        if(developmentCardsState != undefined) this.devCardsValidator = new MechanicValidatorDevelopmentCard(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, developmentCardsState)
        if(progressCardsState != undefined) this.progressCardsValidator = new MechanicValidatorProgressCards(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, progressCardsState)
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.GameStateUpdated: this.triggerOrClearEndTurnSuggestionTimeout(); break
            case UIGameEventEnums.ShowTradeUI: this.clearEndTurnSuggestionTimeout(); break
            case UIGameEventEnums.CloseTradeUI: this.triggerOrClearEndTurnSuggestionTimeout(); break
            default: break
        }
    }

    private triggerOrClearEndTurnSuggestionTimeout() {
        if(this.uiGameManager.gameController.isPlayerSpectator) return
        if(this.uiGameManager.gameController.isReplay) return

        const isNotMyTurn = this.uiGameManager.gameController.isMyTurn == false
        if(isNotMyTurn) this.alreadySuggestedToEndTurn = false

        const shouldSuggestToEndTurn = this.shouldSuggestToEndTurn()
        if(!shouldSuggestToEndTurn) return this.clearEndTurnSuggestionTimeout()

        this.triggerEndTurnSuggestionTimeout()
    }

    private shouldSuggestToEndTurn(): boolean {
        const isNotMyTurn = this.uiGameManager.gameController.isMyTurn == false
        const isNotTurnState = this.uiGameManager.gameController.currentState.turnState != TurnState.Turn && this.uiGameManager.gameController.currentState.turnState != TurnState.SpecialBuildPhase
        const isCurrentlyTakingAnyAction = this.uiGameManager.gameController.currentState.actionState != ActionState.None
        const arePlayersTrading = Object.keys(this.uiGameManager.gameController.tradeState.activeOffers).length > 0
        if(this.alreadySuggestedToEndTurn) return false
        if(isNotMyTurn) return false
        if(isNotTurnState) return false
        if(isCurrentlyTakingAnyAction) return false
        if(arePlayersTrading) return false
        if(this.doIHaveEnoughResourcesToBuildAnything()) return false
        if(this.doIHaveCardToPlay()) return false

        return true
    }

    private doIHaveEnoughResourcesToBuildAnything(): boolean {
        const myPlayerState = this.uiGameManager.gameController.getPlayerState(this.uiGameManager.gameController.myColor)

        const costInformation = getCostInformation(this.uiGameManager.gameController.gameSettings.modeSetting)
        for(const cost of costInformation) {
            if(myPlayerState.resourceCards.hasCardsInInventory(cost.cost)) return true
        }
        return false
    }

    private doIHaveCardToPlay(): boolean {
        const player = this.uiGameManager.gameController.myColor
        const canPlayerUseAtLeastOneDevCard = this.devCardsValidator?.canPlayerUseAtLeastOneDevelopmentCard(player)
        const canPlayerUseAtLeastOneResourceCard = this.progressCardsValidator?.canPlayerUseAtLeastOneProgressCard(player)
        if(canPlayerUseAtLeastOneDevCard) return true
        if(canPlayerUseAtLeastOneResourceCard) return true
        return false
    }

    private triggerEndTurnSuggestionTimeout() {
        this.clearEndTurnSuggestionTimeout()
        this.endTurnSuggestionTimeout = setTimeout(() => this.uiGameManager.eventController.sendEvent(GameAction.PassedTurn, UIGameEventEnums.SuggestAction), this.SUGGESTION_TIMEOUT)
        this.alreadySuggestedToEndTurn = true
    }

    private clearEndTurnSuggestionTimeout() {
        clearTimeout(this.endTurnSuggestionTimeout)
        this.endTurnSuggestionTimeout = undefined
    }
}
